import { render, staticRenderFns } from "./customer-select-ajax.vue?vue&type=template&id=47129974&scoped=true&"
import script from "./customer-select-ajax.vue?vue&type=script&lang=js&"
export * from "./customer-select-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47129974",
  null
  
)

export default component.exports